<template>
  <div class="container">
    <div class="container-content">
      <div class="content-title">资质认证</div>
      <div class="query">
        <MyForm class="search-form" :formOptions="queryForm" :inline="true"></MyForm>
      </div>
      <div class="table">
        <MyTable :table-options="tableOptions" border max-height="65vh" @selection-change="(val) =>{ delList = val }">
           <template #isEnabled="{ row }">
              <el-switch v-model="row.isEnabled" disabled/>
          </template>
          <template #handler="{ row }">
            <el-button
              style="color: #6fcaf7"
              icon="Edit"
              link
              @click="click_edit(row)"
            >编辑</el-button>
            <ConfirmButton icon="Delete" link @confirm="click_delete(row)">删除</ConfirmButton>
          </template>
        </MyTable>
        <MyPagination :params="paginationParams" :total="total" @get-list="getList" ref="paginationRef" />
      </div>
    </div>
    <!-- 新增 -->
    <Dialog
      v-model="addVisible"
      :title="title"
      top="5vh"
      width="30%"
    >
      <MyForm
        class="add-user-form"
        :formOptions="addUserForm"
        :inline="true"
        ref="myFormRef"
        label-width="auto"
      >
        <template #isEnabled="{ formData }">
           <el-switch v-model="formData.isEnabled" />
        </template>
      </MyForm>
      <div class="submit-buttons">
        <el-button @click="addVisible = false">取消</el-button>
        <el-button @click="click_confirm">确定</el-button>
      </div>
    </Dialog>
  </div>
</template>

<script setup>
import MyTable from "@/components/Global/MyTable.vue";
import MyPagination from "@/components/Global/MyPagination.vue";
import { ref, reactive,computed,nextTick } from "vue";
import authApi from "@/api/auth";
import {getConsultantQualification,postConsultantQualification,putConsultantQualification,deleteConsultantQualification} from "@/api/consultant.js";
import { dayjs, ElMessage, ElMessageBox } from "element-plus";
const doctorOptions=ref([])
const title = ref("新增");
// 搜索
const queryForm = reactive({
  itemList: [
    {
      type: "Select",
      label: "咨询师用户：",
      prop: "ConsultantId",
      options: doctorOptions,
      attrs: {
        placeholder: "请选择咨询师",
      },
    },
    {
      type: "Button",
      value: "查询",
      attrs: {
        icon: "Search",
      },
      events: {
        click(formData) {
          Object.assign(paginationParams, formData);
        },
      },
    },
    {
      type: "Button",
      value: "新增",
      attrs: {
        icon: "Plus",
      },
      events: {
        click(formData) {
          addVisible.value = true;
          title.value = "新增";
        },
      },
    },
    {
        type: "Button",
        value: "重置",
        attrs: {
          icon: "RefreshLeft",
        },
        events: {
          click(formData) {
            formData.ConsultantId=""
            paginationParams.ConsultantId = "";
          },
        },
    },
  ],
});

const emoOptions=ref([
  {label:"📜",value:"📜"},
  {label:"🎓",value:"🎓"},
  {label:"📖",value:"📖"},
  {label:"🧘",value:"🧘"},
])
const itemList = computed(() => {
  const base = [
    {
      type: "Select",
      label: "咨询师用户：",
      prop: "consultantId",
      options: doctorOptions,
      attrs:{
        placeholder: "请选择"
      }
    },
    {
      type: "Input",
      label: "资质认证名称：",
      prop: "name",
      attrs:{
        placeholder: "请输入"
      }
    },
    {
      type: "Input",
      label: "资质认证内容：",
      prop: "content",
      attrs:{
        placeholder: "请输入"
      }
    },
    {
      type: "Date",
      label: "获得时间：",
      prop: "obtainTime",
      attrs: {
        valueFormat: "YYYY-MM-DD",
        format: "YYYY-MM-DD",
        type: "date",
        disabledDate: (time) => {
          return time.getTime() > Date.now();
        },
      },
    },
    {
      type: "Select",
      label: "图标：",
      prop: "icon",
      options: emoOptions,
      attrs:{
        placeholder: "请选择"
      }
    },
    {
      type: "Input",
      label: "排序：",
      prop: "sort",
      attrs:{
        placeholder: "请选择",
        type: "number",
      }
    },
    {
      type: "Slot",
      label: "是否启用：",
      prop: "isEnabled",
      slot_name: "isEnabled",
    },
  ];
  return base;
});
const addUserForm = reactive({
  itemList: itemList,
  rules: {
    consultantId: [{ required: true, message: "咨询师用户不能为空", trigger: "blur" }],
    name: [{ required: true, message: "资质认证名称不能为空", trigger: "blur" }],
    content: [{ required: true, message: "资质认证内容不能为空", trigger: "blur" }],
    obtainTime: [{ required: true, message: "获得时间不能为空", trigger: "blur" }],
  },
  // commonAttrs: {
  //   readonly,
  // },
});
// 表格
const tableOptions = reactive({
  colList: [
    { type: "selection", width: 50 },
    { type: "index", label: "序号", width: 70 },
    { label: "资质认证名称", prop: "name" },
    { label: "资质认证内容", prop: "content" },
    { label: "获得时间", prop: "obtainTime" },
    { label: "图标", prop: "icon" },
    { label: "排序", prop: "sort" },
    { label: "是否启用",type: "slot", slot_name: "isEnabled"},
    { type: "slot", slot_name: "handler", label: "操作" },
  ],
  tableData: [],
});
 const doctorData=()=>{
    let obj={
       Type:2,
       SkipCount:0,
       MaxResultCount:999,
    }
    authApi.getUserList(obj).then((res) => {
      doctorOptions.value = res.data.items.map(item=>{
      return {
        label: item.userName,
        value: item.id,
        ...item
      }
    });
    // paginationParams.ConsultantId=doctorOptions.value[0].id
  })
 }
 doctorData()
// 新增资质认证
const addVisible = ref(false);

// 新增资质认证 确认按钮
const myFormRef = ref(null);
const click_confirm = () => {
   const { formRef, formData } = myFormRef.value;
    formData.sort=Number(formData.sort==null?0:formData.sort)
    formRef.validate(async(valid) => {
      if (valid) {
        let res = formData.id ? await putConsultantQualification(formData)
        : await postConsultantQualification(formData);
        ElMessage.success("操作成功");
        addVisible.value = false;
        getList();
      }
    })
};


// 编辑
const click_edit = async(row) => {
  addVisible.value = true;
  title.value = "编辑";
  await nextTick();
  const { formData } = myFormRef.value;
  Object.assign(formData, row);
};
const delList = ref([]);
const click_delete = (row) => {
  deleteConsultantQualification(row.id).then(res=>{
    ElMessage.success("删除成功");
    getList();
  })
}

const paginationParams = reactive({
  ConsultantId: "",
})
const paginationRef = ref();
const total = ref(0);
const getList = (params = paginationRef.value.getList_params) => {
  // if(paginationParams.ConsultantId==""){
  //   return
  // }
  getConsultantQualification(params).then(res=>{
    total.value = res.data.totalCount;
    tableOptions.tableData =  res.data.items;
  });
};
</script>

<style lang="scss" scoped>
.add-user-form {
  padding: 20px 40px;
}
</style>
